"use client";
import ProductCarouselSkeleton from "@components/commerce/product/product-carousel/ProductCarouselSkeleton";
import { Box } from "@ecco/ui/box";
import dynamic from "next/dynamic";
import type { ComponentProps } from "react";
import { useEffect, useRef, useState } from "react";
import type ProductRecommendationsType from "./ProductRecommendations";

type Props = ComponentProps<typeof ProductRecommendationsType>;

const ProductRecommendations = dynamic(() => import("./ProductRecommendations"), {
    ssr: false,
});

export default function DeferredProductRecommendations(props: Props) {
    const placeholderRef = useRef<HTMLDivElement | null>(null);
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        if (shouldRender) return;

        const el = placeholderRef.current;
        if (!el || typeof IntersectionObserver === "undefined") {
            setShouldRender(true);
            return;
        }

        const io = new IntersectionObserver(
            (entries) => {
                if (entries.some((e) => e.isIntersecting)) {
                    setShouldRender(true);
                }
            },
            { rootMargin: "200px 0px" }
        );
        io.observe(el);

        return () => io.disconnect();
    }, [shouldRender]);

    if (!props.recommendations?.length) return null;

    if (shouldRender) return <ProductRecommendations {...props} />;

    return (
        <Box ref={placeholderRef}>
            <ProductCarouselSkeleton height={props.carouselHeight} width={props.tileWidth} />
        </Box>
    );
}
